<template>
	<div class="wp100 oh">
		<!-- 头部 -->
		<div class="disf jc-s ai-c pl10 mb5" style="height: 32px;">
			<p><i class="fs16 sz szxueweirenzheng mr5" style="color: #909399"></i>《上海教育科研》</p>
			<div>
			</div>
		</div>

		<div class="wp100 bg-c-fff oh" style="height: calc(100vh - 123px);">
			<div class="p10 disf"
				style="width: calc(100% + 13px);height: calc(100vh - 123px);overflow-y: auto;flex-wrap: wrap;justify-content: space-between;"
				v-infinite-scroll="loadMore" infinite-scroll-delay infinite-scroll-immediate>
				<div style="width: 290px;max-height: 430px;" class="mr20 mb20 common-shadow"
					v-for="magazine in magazineList" v-if="magazineList.length > 0">
					<a :href="`${basePdf}${magazine.pdf_url}`" target="_block">
						<img :src="`${basePic}${magazine.cover_img}`" style="width: 288px;max-height: 390px;" />
						<div class="ta-c h40 lh40 fs14" style="color: #000000;">{{ magazine.title }}</div>
					</a>
				</div>
				
				<div class="mb20 mr20" style="width: 290px;" v-show="magazineList.length % 4 != 0" v-for="(item1,index1) in 4 - magazineList.length % 4"></div>
			</div>
		</div>
	</div>
</template>


<script>
	import global from "../../../global";
	export default {
		name: "swiper",
		data() {
			return {
				// 杂志类型
				column: 0,
				// 页码
				page: 1,
				magazineList: [],
				basePic: global.picUrl,
				basePdf: global.fileUrl,
			};
		},


		mounted() {
			// 初始化数据
			let searchParams = {
				column: this.column,
				page: this.page,
			};

			// 获取初始化列表数据
			this.$api.magazine.list(searchParams).then((res) => {
				this.magazineList = res.Data.List;
				this.page = 2;
			});
		},


		methods: {
			loadMore() {
				// 滚动加载更多数据
				let searchParams = {
					column: this.column,
					page: this.page
				};

				// 获取初始化列表数据
				this.$api.magazine.list(searchParams).then((res) => {
					if (res.Data.List.length > 0) {
						this.magazineList = this.magazineList.concat(res.Data.List);
						this.page = this.page + 1;
					}

				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.box {
		background-color: white;
		border: 1rpx solid #efefef;
	}

	.time {
		font-size: 13px;
		color: #999;
	}

	.bottom {
		margin-top: 13px;
		line-height: 12px;
	}

	.button {
		padding: 0;
		float: right;
	}

	.image {
		width: 300px;
		display: block;
	}

	.clearfix:before,
	.clearfix:after {
		display: table;
		content: "";
	}

	.clearfix:after {
		clear: both;
	}

	.chooseSource {
		border-bottom: 2px solid #f93e61;
		color: #f93e61;
	}

	.stateNum {
		background-color: #f93e61;
	}

	.flex {
		flex: 1;
		width: 33%;
		min-width: 100%;
		max-width: 100%;
	}

	.zazhi {
		display: flex;
		flex-wrap: wrap;
	}
	
	.common-shadow {
		border: 1px solid #e4e7ed;
		box-shadow: 0px 1px 15px 1px rgba(0, 0, 0, 0.1);
	}
</style>
